// extracted by mini-css-extract-plugin
export default {"chipsContainer":"chipsContainer--p9qdE","container":"container--XbVey"};